import React, { useState, useEffect } from "react";
import { Autocomplete, Button, TextField } from "@mui/material";
import { Add, Close, Delete } from "@mui/icons-material/";

import { getTipos_ceremonias } from "../../../helpers/ceremonias";
import { deleteRol as deleteRolHelper } from "../../../helpers/roles";
import { Loading } from "../../../common/components";
import { Acolitos } from "./Acolitos";
import { getPuestosByCeremonia } from "../../../helpers/puestos";
import { CustomModal } from "../../../common/components/CustomModal";

export const Misa_card = ({ ceremonia, onEdit }) => {
  const [stateLocal, setStateLocal] = useState({ ...ceremonia });

  const [tiposCeremonias, setTiposCeremonias] = useState([]);
  const [loadingTC, setLoadingTC] = useState(true);

  const [puestos, setPuestos] = useState([]);
  const [loadingPuestos, setLoadingPuestos] = useState(false);

  const [alertDelete, setAlertDelete] = useState(false);
  const [idAcolitoDelete, setIdAcolitoDelete] = useState(-1);

  const [nuevoAcolito, setNuevoAcolito] = useState({
    id: 1,
    id_acolito: 0,
    id_puesto: 0,
    nombre: "",
    puesto: "",
  });

  useEffect(() => {
    // Obtener tipos de ceremonias
    getTipos_ceremonias().then((t) => {
      setTiposCeremonias(t);
      setLoadingTC(false);
    });
  }, []);

  useEffect(() => {
    onEdit(stateLocal);
  }, [stateLocal]);

  useEffect(() => {
    if (stateLocal.tipo_misa) {
      setLoadingPuestos(true);
      getPuestosByCeremonia(stateLocal.tipo_misa)
        .then((p) => {
          setPuestos(p);
          setLoadingPuestos(false);
        })
        .catch((e) => {
          console.log("Error al obtener los puestos: ", e);
        });
    }
  }, [stateLocal.tipo_misa]);

  const handleAddAcolito = () => {
    const id_nuevoAcolito = nuevoAcolito.id + 1;

    setNuevoAcolito({
      id: id_nuevoAcolito,
      id_acolito: 0,
      nombre: "",
      id_puesto: 0,
      puesto: "",
    });

    setStateLocal({
      ...stateLocal,
      acolitos: [
        ...stateLocal.acolitos,
        {
          id: id_nuevoAcolito,
          id_acolito: 0,
          nombre: "",
          id_puesto: 0,
          puesto: "",
        },
      ],
    });
  };

  const handleEditAcolito = (acolito) => {
    const array_ac = stateLocal.acolitos.map((a) => {
      if (a.id === acolito.id) {
        return acolito;
      }
      return a;
    });

    setStateLocal({ ...stateLocal, acolitos: array_ac });
  };

  const handleDeleteAcolito = (id) => {
    setAlertDelete(true);
    setIdAcolitoDelete(id);
  };

  const deleteRol = async () => {
    const newAcolitos = stateLocal.acolitos.filter(
      (a) => a.id !== idAcolitoDelete
    );
    setStateLocal({ ...stateLocal, acolitos: newAcolitos });
    if (typeof idAcolitoDelete !== "number") {
      // Eliminar acolito de la base de datos
      await deleteRolHelper({ id: idAcolitoDelete });
    }
    setAlertDelete(false);
  };

  //Mostrar cargando si no se han cargado los acolitos
  if (loadingTC) {
    return <Loading texto="Obteniendo tipos de ceremonias" />;
  }

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        padding: 15,
      }}
    >
      {loadingPuestos && <Loading texto="Obteniendo puestos" />}
      <div
        style={{
          display: "flex",
          // flex: 1,
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      ></div>
      <div
        style={{
          display: "flex",
          padding: 10,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Autocomplete
          disablePortal
          options={tiposCeremonias}
          getOptionLabel={(option) => option.nombre}
          value={
            tiposCeremonias.find((tipo) => tipo.id === stateLocal.tipo_misa) ||
            null
          }
          sx={{ width: 200 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Tipo de ceremonia"
              //   error
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(event, value) => {
            if (value) {
              // Quitar el id_puesto de los acolitos
              const aco = stateLocal.acolitos.map((acolito) => {
                return {
                  ...acolito,
                  id_puesto: 0,
                  puesto: "",
                };
              });
              setStateLocal({
                ...stateLocal,
                tipo_misa: value.id,
                acolitos: aco,
              });
            } else {
              const aco = stateLocal.acolitos.map((acolito) => {
                return {
                  ...acolito,
                  id_puesto: 0,
                  puesto: "",
                };
              });
              setStateLocal({ ...stateLocal, tipo_misa: "", acolitos: aco });
            }
          }}
          noOptionsText="Sin resultados"
          style={{ marginBottom: 20 }}
        />
        <Autocomplete
          disablePortal
          freeSolo
          options={["07:15", "08:00", "18:30", "19:00"]}
          value={stateLocal.horario || ""}
          getOptionLabel={(option) => option}
          sx={{ width: 200 }}
          renderInput={(params) => <TextField {...params} label="Hora" />}
          isOptionEqualToValue={(option, value) => option === value}
          onInputChange={(event, value) => {
            setStateLocal({ ...stateLocal, horario: value });
          }}
          noOptionsText="Sin resultados"
        />
      </div>
      <div
        style={{
          display: "flex",
          flex: 2,
          flexDirection: "column",
          alignSelf: "center",
        }}
      >
        {stateLocal.acolitos.map((acolito) => {
          return (
            <Acolitos
              key={acolito.id}
              acolito={acolito}
              tipo_misa={stateLocal.tipo_misa}
              onEdit={handleEditAcolito}
              onDelete={handleDeleteAcolito}
              puestos={puestos}
            />
          );
        })}
        {stateLocal.tipo_misa && (
          <div style={{ backgroundColor: "" }}>
            <Button startIcon={<Add />} onClick={handleAddAcolito}>
              Agregar Acólito
            </Button>
          </div>
        )}
      </div>

      {/* Modal para confirmar que desea eliminar el acólito */}

      <CustomModal
        open={alertDelete}
        title="¿Confirmas que deseas eliminar esta asignación?"
        text="Esta acción no se puede deshacer"
        txtBtn1="Eliminar"
        txtBtn2="Cancelar"
        funBtn1={() => deleteRol()}
        funBtn2={() => setAlertDelete(false)}
        iconBtn1={<Delete />}
        iconBtn2={<Close />}
      />
    </div>
  );
};
